import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const OverviewTable = ({ items }) => {
  const [filtered, setFiltered] = useState("");
  const [viewCustomer, setViewCustomer] = useState();
  const [currentCustomers, setCurrentCustomers] = useState(items);
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  useEffect(() => {
    setViewCustomer(
      user_permissions?.some(
        (permission) => permission.name === "view customer details"
      )
    );
  }, [user_permissions]);

  useEffect(() => {
    if (filtered !== "") {
      setCurrentCustomers(items.filter((item) => item.status === filtered));
    } else {
      setCurrentCustomers(items);
    }
  }, [filtered, items]);

  return (
    <>
      {/* Table row */}
      <div className='row'>
        <h4>Most Recent Individual Customers</h4>
        <div className='col-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='row mb-2'>
                <div className='col-sm-9 mt-2 '>
                  <ul class='nav nav-tabs nav-bordered mb-'>
                    <li class='nav-item' onClick={() => setFiltered("")}>
                      <a
                        href='#home-b1'
                        data-bs-toggle='tab'
                        aria-expanded='false'
                        class='nav-link active'
                        // ref={allIndividualCustomers}
                      >
                        <i class='mdi mdi-home-variant d-md-none d-block'></i>
                        <span class='d-none d-md-block'>All</span>
                      </a>
                    </li>
                    <li class='nav-item' onClick={() => setFiltered("2")}>
                      <a
                        href='#profile-b1'
                        data-bs-toggle='tab'
                        aria-expanded='true'
                        class='nav-link'
                      >
                        <i class='mdi mdi-account-circle d-md-none d-block'></i>
                        <span class='d-none d-md-block'>Active</span>
                      </a>
                    </li>
                    <li class='nav-item' onClick={() => setFiltered("1")}>
                      <a
                        href='#settings-b1'
                        data-bs-toggle='tab'
                        aria-expanded='false'
                        class='nav-link'
                      >
                        <i class='mdi mdi-settings-outline d-md-none d-block'></i>
                        <span class='d-none d-md-block'>Pending Approval</span>
                      </a>
                    </li>
                    <li class='nav-item' onClick={() => setFiltered("3")}>
                      <a
                        href='#settings-b1'
                        data-bs-toggle='tab'
                        aria-expanded='false'
                        class='nav-link'
                      >
                        <i class='mdi mdi-settings-outline d-md-none d-block'></i>
                        <span class='d-none d-md-block'>Rejected</span>
                      </a>
                    </li>
                    <li class='nav-item' onClick={() => setFiltered("4")}>
                      <a
                        href='#settings-b1'
                        data-bs-toggle='tab'
                        aria-expanded='false'
                        class='nav-link'
                      >
                        <i class='mdi mdi-settings-outline d-md-none d-block'></i>
                        <span class='d-none d-md-block'>Closed</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className='col-sm-3'>
                  {user_permissions?.some(
                    (permission) =>
                      permission.name === "view customers - corporate"
                  ) &&
                    user_permissions?.some(
                      (permission) => permission.name === "customer module"
                    ) &&
                    items?.length > 0 && (
                      <div className='text-sm-end'>
                        <Link
                          to={"/admin/individual-customers"}
                          className='btn btn-light mb-2 bg-warning text-white p'
                        >
                          <i className='uil-eye me-2 mr-0'></i>see more
                        </Link>
                      </div>
                    )}
                </div>
              </div>

              <div className='table-responsive'>
                <div
                  id='products-datatable_wrapper'
                  className='dataTables_wrapper dt-bootstrap5 no-footer'
                >
                  <div className='row'>
                    <div className='col-sm-12'>
                      <table
                        className='table table-centered table-striped nowrap w-100 no-footer'
                        //   ref={ICPdfRef}
                      >
                        <thead>
                          <tr>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "120.8px" }}
                              aria-label='Customer: activate to sort column ascending'
                            >
                              Status
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "225.8px" }}
                              aria-label='Customer: activate to sort column ascending'
                            >
                              Names
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "144.8px" }}
                              aria-label='Phone: activate to sort column ascending'
                            >
                              Gender
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "147.8px" }}
                            >
                              Customer Type
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "147.8px" }}
                              aria-label='Email: activate to sort column ascending'
                            >
                              Customer Id
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "156.8px" }}
                              aria-label='Location: activate to sort column ascending'
                            >
                              State
                            </th>
                            <th
                              className='sorting sorting_asc'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "146.8px" }}
                            >
                              Phone Number
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "165.8px" }}
                              aria-label='Status: activate to sort column ascending'
                            >
                              Date Registered
                            </th>
                            {viewCustomer &&
                              user_permissions?.some(
                                (permission) =>
                                  permission.name === "customer module"
                              ) && (
                                <th
                                  tabIndex='0'
                                  rowSpan='1'
                                  colSpan='1'
                                  style={{ width: "100.8px" }}
                                ></th>
                              )}
                          </tr>
                        </thead>

                        <tbody>
                          {currentCustomers?.map((item, i) => (
                            <tr>
                              <td>
                                <span
                                  className={`badge ${
                                    item?.status === "1" &&
                                    "badge-warning-lighten"
                                  } ${
                                    item?.status === "2" &&
                                    "badge-success-lighten"
                                  } ${
                                    item?.status === "3" &&
                                    "badge-danger-lighten"
                                  } ${
                                    item?.status === "4" &&
                                    "badge-secondary-lighten"
                                  } fw-normal rounded-4`}
                                  style={{
                                    fontSize: "10px",
                                    padding: "5px 18px",
                                  }}
                                >
                                  {item?.status === "1" && "Pending Approval"}
                                  {item?.status === "2" && "Active"}
                                  {item?.status === "3" && "Rejected"}
                                  {item?.status === "4" && "Closed"}
                                </span>
                              </td>
                              <td>
                                {item?.first_name + " " + item?.last_name}
                              </td>
                              <td className='table-user'>{item?.gender}</td>
                              <td className='table-user'>
                                {item?.customer_type}
                              </td>
                              <td className='text-dark'>{item?.customer_id}</td>
                              <td>{item?.state_of_origin}</td>
                              <td>{item?.phone_number}</td>
                              <td>
                                {moment(item?.created_at).format("D/M/Y")}
                              </td>

                              {viewCustomer &&
                                user_permissions?.some(
                                  (permission) =>
                                    permission.name === "customer module"
                                ) && (
                                  <td className='text-center'>
                                    <Link
                                      to={`/admin/customer-profile/${item?.id}`}
                                      className='bg-primary-1 text-white px-2 py-1 rounded'
                                      state={item?.id}
                                    >
                                      view
                                    </Link>
                                  </td>
                                )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {currentCustomers && currentCustomers?.length < 1 ? (
                      <h5 className='alert alert-info'>No result found!</h5>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- end card-body--> */}
          </div>
          {/* <!-- end card--> */}
        </div>
      </div>
      {/*  End table row */}
    </>
  );
};

export default OverviewTable;
